import theme from '../../../../../../lib/theme';
import { ExplainerProductProps } from './ExplainerProduct';

const { layouts, colors, corners, scale, shadows, media } = theme;

export default ({
  brand = 'sas',
  backgroundColor = 'primary',
  shrink,
  href,
}: ExplainerProductProps) => ({
  product: {
    display: 'block',
    width: '100%',
    maxWidth: '100%', // shrink ? 260 : 355,
    backgroundColor: colors[brand][backgroundColor],
    borderRadius: corners.l,
    overflow: 'hidden',
    textDecoration: 'unset',
    transition: 'all 150ms linear',
    cursor: href ? 'pointer' : 'unset',

    [media.m.up]: {
      maxWidth: '45%',
    },

    '&:hover': !href
      ? {}
      : {
          boxShadow: shadows.low,
        },
  },

  productImage: {
    width: '100%',
    display: 'none !important',

    [media.m.up]: {
      display: 'block !important',
    },
  },

  productInner: {
    ...layouts.spacedColumn('m'),

    alignItems: 'flex-start',
    padding: shrink ? scale.s : scale.m,

    '& ul': {
      padding: 0,
      margin: `0 0 0 ${scale.s}`,
    },

    '& ul > li': {
      marginBottom: scale.xxs,
    },

    '& ul > li:last-child': {
      marginBottom: 0,
    },
  },

  buttonIcon: {
    marginLeft: scale.xxxxs,
  },
});
